import { Button } from '@/routes/_embaUserLayout/-components/Button';
import { LessonTitle } from '@/routes/_embaUserLayout/-components/LessonTitle';
import type React from 'react';

import BackgroundOfficeImage from '@/assets/images/office.jpg';
import styles from './index.module.scss';

export type CourseLessonDocumentPageProps = {
  lessonName: string;
  chapterName: string;
  description: string;
  onClickDownload: () => void;
  isLoading: boolean;
};

export const CourseLessonDocumentPageComponent = ({
  lessonName,
  chapterName,
  description,
  onClickDownload,
  isLoading,
}: CourseLessonDocumentPageProps) => {
  return (
    <>
      <LessonTitle chapterName={chapterName} lessonName={lessonName} />
      <div
        className={styles.documentWrapper}
        style={{
          backgroundImage: `url(${BackgroundOfficeImage})`,
        }}
      >
        <div className={styles.documentArea}>
          <div className={styles.documentAreaInner}>
            <p className={styles.description}>{description}</p>
            <div className={styles.buttonArea}>
              <Button onClick={onClickDownload} disabled={isLoading}>
                資料をダウンロードする
              </Button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
